import verificarNotificacao from "./verificarNotificacao"
import verificarDesconto from "./verificarDesconto"
import entregarDoc from "./entregarDoc"
import alvaraVencido from "./alvaraVencido"
import alvaraFuncionamento from "./alvaraFuncionamento"

export default [
  {
    label: "Verificar notificação",
    checklist: verificarNotificacao,
    tipoFormulario: ["verificar_notificacao"],
  },
  {
    label: "Verificar desconto",
    checklist: verificarDesconto,
    tipoFormulario: ["verificar_desconto"],
  },
  {
    label: "Entregar Documentos",
    checklist: entregarDoc,
    tipoFormulario: ["entregar_doc"],
  },
  {
    label: "Verificar Alvará Vencido",
    checklist: alvaraVencido,
    tipoFormulario: ["verificar_alvara_vencido"],
  },
  {
    label: "Alvará de Funcionamento",
    checklist: alvaraFuncionamento,
    tipoFormulario: ["alvara_concluir_vistoria"],
  },
]
